module.exports = __webpack_public_path__ + "static/img/防灾体验.611f21e2.png";